import { useGetCurrentUser } from './use-get-current-user';

export const useFeatureFlags = () => {
    const { data: user } = useGetCurrentUser();
    const flags = user!.feature_flags;

    return flags;
};
